<template>
  <div style="background-color: #fafafa;">
    <van-nav-bar
      title="盘点"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      :z-index="998"
      fixed
    />
    <div class="box">
      <div
          style="display: flex;justify-content: space-between;align-items: center;"
      >
        <span>类型：{{this.$route.params.categoryName}}</span>
      </div>
    </div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" style="margin-top:0">
      <van-list
        v-model="loading"
        :finished="finished"
        @load="onLoad"
        finished-text="没有更多了"
      >
        <div
          v-for="data in list"
          class="card"
          :key="data.uuid"
          @click="openDetail(data.uuid,data.isEnable, data.skuName,data.codeName,data.stocktakingSkuNumber,data.stocktakingNumber,data.status)"
        >
          <table class="layout">
            <tr>
              <td colspan="2" class="content">
                <p>
                  <span>商品编码：</span>
                  <span>{{ data.codename || "无" }}</span>
                </p>
                <p>
                  <span>商品名称：</span>
                  <span>{{ data.skuName || "无" }}</span>
                </p>
                <p>
                  <span>数量：</span>
                  <span>{{ data.stocktakingSkuNumber || "0" }}</span>
                </p>
                <p>
                  <span>盘点数量：</span>
                  <span>{{ data.stocktakingNumber || "0" }}</span>
                </p>
                <p>
                  <span>盘点状态：</span>
                  <span>{{ data.statusname || "无" }}</span>
                </p>
              </td>
            </tr>
          </table>
        </div>
      </van-list>
    </van-pull-refresh>
    <div class="recordBox" v-if="status != '2'" >
      <div
          style="display: flex;justify-content: space-between;align-items: center;"
      >
        <van-button
            style="height:30px;font-size: 14px;"
            type="info"
            size="large"
            @click="stockTakingComplete"
        >盘点完成</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import {
  Tab,
  Tabs,
  Panel,
  Button,
  List,
  Search,
  Popup,
  PullRefresh,
  NavBar,
  Tag,
  Col,
  Row,
  Sidebar,
  SidebarItem,
  DatetimePicker,
  Field,
  DropdownMenu,
  DropdownItem,
  Icon, Toast,
} from "vant";
import userInfo from "../../store/userInfo";
import stockTakingService from "../../service/stockTakingService";
// import moment from "moment";
import { formatDictionary } from "../../utils/dictionary";
import { API_URL } from "../../common/config";

export default {
  data: function() {
    return {
      list: [], //数据列表
      loading: false,
      finished: false, //数据加载完成
      pageIndex: 0, //第几页
      value: "", //搜索值
      refreshing: false, //是否刷新
      type: 2, //选项卡index
      status: this.$route.params.status, //上级盘点状态
    };
  },
  store: userInfo,
  components: {
    [Tab.name]: Tab,
    [Tag.name]: Tag,
    [NavBar.name]: NavBar,
    [Tabs.name]: Tabs,
    [Button.name]: Button,
    [PullRefresh.name]: PullRefresh,
    [Panel.name]: Panel,
    [List.name]: List,
    [Col.name]: Col,
    [Row.name]: Row,
    [Search.name]: Search,
    [Popup.name]: Popup,
    [Sidebar.name]: Sidebar,
    [SidebarItem.name]: SidebarItem,
    [DatetimePicker.name]: DatetimePicker,
    [Field.name]: Field,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Icon.name]: Icon,
  },
  computed: {
    userId() {
      return this.$store.getters.getUserId;
    },
    avatarUrl() {
      return API_URL + "/oa/common/attachment/showImage?id=";
    },
  },
  created: async function() {
    // eslint-disable-next-line no-console
    console.log(this.$route.params.uuid); //详情id
  },
  methods: {
    async onLoad() {
      this.pageIndex++;
      let resp = await stockTakingService.getStockTakingCategorySkuList(
        this.pageIndex,
        this.value,
        this.$route.params.uuid
      );
      if (resp.data.Status == "1" && resp.data.Data.data.length > 0) {
        // resp.data.Data.data.forEach((item) => {
        //   item.createTime = moment(item.createTime).format("YYYY-MM-DD");
        // });
        formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
      }
      this.loading = false;
      this.refreshing = false;
      formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
      this.list = [...this.list, ...resp.data.Data.data];
      this.finished = resp.data.Data.total <= this.list.length;
    },
    onRefresh() {
      this.finished = false;
      this.pageIndex = 0;
      this.list = [];
      this.onLoad();
    },
    openDetail(uuid,isEnable,sukName,codeName,stocktakingSkuNumber,stocktakingNumber,status) {
      this.$router.push({ path: "/electronicErp/stockTakingCategorySkuBarcode/" + uuid +"/" + isEnable + "/" +
            sukName + "/" + codeName + "/" + stocktakingSkuNumber + "/" + stocktakingNumber + "/" + status});
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    async stockTakingComplete() {
      let is = false;
      let sku = "";
      this.list.forEach(item=>{
        if(item.status == "1"){
          if(sku!=""){
            sku += ",";
          }
          sku += item.skuIdname
          is = true ;
        }
      })
      if(is){
        Toast.fail(sku + " 未完成盘点")
        return ;
      }
      let resp = await stockTakingService.updateStocktakingCategoryStatus(
          this.$route.params.uuid
      );
      if (resp.data.Status === '1') {
        this.status = "2"
        Toast.success('操作成功');
      } else {
        Toast.fail(resp.data.Message);
      }
    },
  },
};
</script>

<style>
.dropdownItem > .van-dropdown-item > .van-popup {
  max-height: 100%;
  height: 100%;
}
.van-popup--right {
  width: 100%;
  height: 100%;
}
.van-nav-bar {
  z-index: 99999;
}
.van-icon {
  margin-right: 0.6rem;
  color: #4090fa;
}

.icon {
  margin-left: 1rem;
}
.recordBox {
  padding: 0.5rem 0.5rem;
  box-sizing: border-box;
  margin-top: 2rem;
  bottom: 0;
  position: fixed;
  width: 100%;
  background: #1989fa;
  color: #fff;
}
.box {
  padding: 0.5rem 0.5rem;
  box-sizing: border-box;
  margin-top: 3rem;
  bottom: 0;
  position: initial;
  width: 100%;
  background: #fff;
  color: #969799;
}
</style>
